module.exports = __webpack_public_path__ + "img/09.7b160724.png";